import { render, staticRenderFns } from "./CentralDetails.vue?vue&type=template&id=4e65fbcc&"
import script from "./CentralDetails.vue?vue&type=script&lang=js&"
export * from "./CentralDetails.vue?vue&type=script&lang=js&"
import style0 from "./CentralDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports